export default [
  {
    name: 'CustomersList',
    path: 'customers',
    component: () => import('pages/customers/list/CustomersList.vue')
  },
  {
    name: 'CustomersCreate',
    path: 'customers/new',
    component: () => import('pages/customers/CustomersCreate.vue')
  },
  {
    name: 'CustomersImports',
    path: '/customers/imports',
    component: () => import('pages/customers/imports/CustomersImports.vue')
  },
  {
    path: '/customers/:id',
    component: () => import('layouts/CustomersLayout.vue'),
    redirect: { name: 'CustomersSummarySingle' },
    children: [
      {
        path: 'summary',
        name: 'CustomersSummarySingle',
        meta: { useOverlay: true },
        component: () => import('pages/customers/tabs/summary-single/CustomersSummarySingle.vue')
      },
      {
        path: 'personal-data/edit',
        name: 'CustomersPersonalDataEdit',
        meta: { useOverlay: true },
        component: () => import('pages/customers/tabs/CustomersPersonalDataForm.vue')
      },
      {
        path: 'documents',
        name: 'CustomersDocumentsList',
        component: () => import('pages/customers/tabs/CustomersDocumentsList.vue')
      },
      {
        path: 'professional-data/edit',
        name: 'CustomersProfessionalDataEdit',
        component: () => import('pages/customers/tabs/CustomersProfessionalDataForm.vue')
      },
      {
        path: 'address/edit',
        name: 'CustomersAddressEdit',
        component: () => import('pages/customers/tabs/address-edit/CustomersAddressEdit.vue')
      },
      {
        path: 'incomes/edit',
        name: 'CustomersIncomesEdit',
        component: () => import('pages/customers/tabs/CustomersIncomesForm.vue')
      },
      {
        path: 'heritage/edit',
        name: 'CustomersHeritageEdit',
        component: () => import('pages/customers/tabs/CustomersHeritageForm.vue')
      },
      {
        path: 'financial-commitments/edit',
        name: 'CustomersFinancialCommitmentsEdit',
        component: () => import('pages/customers/tabs/CustomersFinancialCommitmentsForm.vue')
      },
      {
        path: 'bank-info/edit',
        name: 'CustomersBankInfoEdit',
        component: () => import('pages/customers/tabs/CustomersBankInfoForm.vue')
      },
      {
        path: 'dependents/edit',
        name: 'CustomersDependentsEdit',
        component: () => import('pages/customers/tabs/CustomersDependentsForm.vue')
      },
      {
        path: 'personal-references/edit',
        name: 'CustomersPersonalReferencesEdit',
        component: () => import('pages/customers/tabs/CustomersPersonalReferencesForm.vue')
      },
      {
        path: 'metadata',
        name: 'CustomersMetadataList',
        component: () => import('pages/customers/tabs/metadata/CustomersMetadataList.vue')
      }
    ]
  }
]
